import moment from "moment";
import { PollProps } from "../../../store/types/auth_svc";


export const p_genEmptyPoll = (poll_campaign_id:string):PollProps => {
    return {
        poll_campaign_id,
        poll_id:'',
        poll_question: '',
        poll_type: 'select',
        input_type: undefined,
        minimum_stake: 1,
        tie_breaker:false,
        manual_close_only: false,
        show_responses: true,
        end_datetime: moment().add(1, 'day'),
        status: 'pending',
        create_datetime: '',
        last_update_datetime: ''
    }
}


export const poll_randomRGBA = (opacity:number) => {
    var o = Math.round, r = Math.random, s = 255;
    let rgba = 'rgba(' + o(r()*s) + ',' + o(r()*s) + ',' + o(r()*s) + ',' + `${opacity}` + ')';
    return rgba
}